<mat-dialog-content class="mat-typography">
<div  [dir]="direction">
  <img alt="Image"  [src]="imagePath">
</div>

</mat-dialog-content>

<!-- <mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button>
</mat-dialog-actions> -->
